import styled from 'styled-components';

const PageTitle = styled.h2`
  font-size: 26px;
  line-height: 34px;
  color: #180a33;
  margin: 0;
  font-weight: 400;
  text-align: ${({ align }) => align || 'center'};
  max-width: ${({ maxWidth }) => maxWidth || '506px'};
  white-space: pre-wrap;

  @media screen and (max-width: 767px) {
    font-size: 20px;
    line-height: 26px;
    max-width: 312px;
  }
`;

export default PageTitle;
